import React from "react";
import { Outlet } from "react-router-dom";
import { Link } from "react-router-dom";

export default function CheckoutLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* نوار بالایی */}
      <div className="w-full bg-[#1E3A5F] text-[#FFC107] flex justify-between items-center px-4 py-2 md:px-8 shadow-md">
        {/* لوگو */}
        <Link to="/" className="flex items-center">
          <img
            src="/images/logo.png"
            alt="Company Logo"
            className="w-[40px] h-[40px] object-contain"
          />
        </Link>
      </div>

      {/* محتوا */}
      <Outlet/>
    </div>
  );
}
